"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPlaceToRemoteToken = exports.deleteUserApiToken = exports.editPersonalInfoApiToken = exports.profileApiToken = void 0;
var Api_1 = require("@/api/remote/Api");
exports.profileApiToken = function (languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/place/getplaces",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: {
            searchString: '',
            pageNumber: 0,
            sortBy: 1,
        },
    });
};
exports.editPersonalInfoApiToken = function (personalInfo, languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/personalinfo/editpersonalinfo",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: personalInfo,
    });
};
exports.deleteUserApiToken = function (languageCode, token) {
    return Api_1.api().request({
        method: 'GET',
        url: languageCode + "/profile/deleteuser",
        headers: {
            'X-XSRF-TOKEN': token,
        }
    });
};
exports.addPlaceToRemoteToken = function (name, address, lat, lng, languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/place/addplace",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: {
            placeName: name,
            latitude: lat,
            longitude: lng,
        },
    });
};
